export const getProjectTableTheme = () => {
  return {
    Table: `
        --data-table-library_grid-template-columns: minmax(280px, 1fr) 75px 140px 90px 75px 100px 210px;
      `,
    HeaderRow: `
        padding: 4px 16px;
      `,
    BaseCell: `
        padding: 3px 16px;
      `,
  };
};
